module.exports = __webpack_public_path__ + "img/form-5.d2651942.png";